import { styled } from '@compiled/react';
import styled2 from 'styled-components';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Link } from '@atlassian/help-center-common-component/analytics/link';

export const SEARCH_BAR_HEIGHT = token('space.1000', '80px');

// eslint-disable-next-line rulesdir/no-styled-export
export const Title = styled2.h3`
    ${mixins.clamp};
    margin: 0;
    font-weight: normal;
    font-size: ${token('space.200', '16px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Snippet = styled2.p`
    color: ${token('color.text', colors.N800)};
    margin-top: ${token('space.100', '8px')};
    padding-right: ${token('space.200', '16px')};
    ${mixins.multiLineClamp(3, 20)};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LinkContainer = styled2(Link)`
    display: flex;
    border-radius: ${token('border.radius.100', '3px')};
    ${mixins.raiseUpOnHoverOrFocus()};
    background-color: ${token('elevation.surface.raised', colors.N0)};
    padding: ${token('space.200', '16px')};
    margin: ${token('space.100', '8px')} 0 0;
    &:hover,
    &:focus {
        background: ${token('elevation.surface.raised', colors.N0)};
        text-decoration: none;
    }
    &:hover h3,
    &:focus h3 {
        color: ${(props) => token('color.link', props.theme.color)};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ResultTitle = styled.h2({
    paddingTop: token('space.200', '16px'),
    marginTop: token('space.0', '0px'),
    textTransform: 'uppercase',
    fontSize: token('space.150', '12px'),
    fontWeight: 'bold',
    color: token('color.background.accent.gray.subtler', colors.N300),
});

// eslint-disable-next-line rulesdir/no-styled-export
export const ResultList = styled.ul({
    listStyleType: 'none',
    padding: 0,
});

// eslint-disable-next-line rulesdir/no-styled-export
export const Img = styled.img({
    width: token('space.1000', '80px'),
    padding: token('space.200', '16px'),
});
